module.exports = __webpack_public_path__ + "img/arya-blue.3b13184e.png";